import {Component, Input} from '@angular/core';
import {NgSwitch, NgSwitchCase, NgSwitchDefault} from '@angular/common';

@Component({
    selector: 'cdss-emotion-icon',
    standalone: true,
    imports: [NgSwitch, NgSwitchCase, NgSwitchDefault],
    templateUrl: './emotion-icon.component.html',
    styleUrl: './emotion-icon.component.scss'
})
export class EmotionIconComponent {
    @Input() emoji: string | null = null;
}
